import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import BasicContentSection from '../components/basic-content-section/BasicContentSection';
import PrevConferences from '../components/prev-conferences/PrevConferences';
import Layout from '../components/layout/Layout';
import AboutHeaderSection from '../components/about-header-section/AboutHeaderSection';
import {
  AboutPageDescription,
  TeamImage,
  AboutGraphicGridDesktop1,
} from '../page-styles/about.style';
import {
  MarginContainer,
  GraphicGridDesktop,
  GraphicGridMobile,
} from '../lib/shared';
import NavGradient from '../components/nav-gradient/NavGradient';
import GetInvolvedPreview from '../components/get-involved-preview/GetInvolvedPreview';
import { icons } from '../style/icons';
import Head from '../components/head/Head';

const AboutPage = () => {
  const pageQuery = useStaticQuery(graphql`
    query aboutPageQuery {
      prismicAboutPage {
        data {
          about_title1 {
            text
          }
          about_title2 {
            text
          }
          about_title3 {
            text
          }
          about_page_description {
            text
          }
          conference_list {
            conference_info {
              document {
                ... on PrismicPreviousConferences {
                  id
                  data {
                    prev_conferences_title {
                      text
                    }
                    conference_list {
                      conference_year {
                        text
                      }
                      conference_name {
                        text
                      }
                      conference_link {
                        url
                      }
                    }
                  }
                }
              }
              id
            }
          }
          about_page_sections {
            about_page_section {
              document {
                ... on PrismicBasicContentSection {
                  id
                  data {
                    button_link {
                      url
                    }
                    button_text {
                      text
                    }
                    section_description {
                      text
                    }
                    section_title {
                      text
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const {
    prismicAboutPage: {
      data: {
        about_title1: aboutTitle1,
        about_title2: aboutTitle2,
        about_title3: aboutTitle3,
        about_page_description: aboutDescription,
        conference_list: confList,
        about_page_sections: aboutSections,
      },
    },
  } = pageQuery;

  return (
    <Layout redLine={true}>
      <Head title="About" />
      <NavGradient />
      <AboutHeaderSection
        title1={aboutTitle1}
        title2={aboutTitle2}
        title3={aboutTitle3}
      />
      <MarginContainer>
        <AboutPageDescription>{aboutDescription.text}</AboutPageDescription>
      </MarginContainer>
      <AboutGraphicGridDesktop1
        src={icons.ABOUT_GRAPHIC_GRID_1_DESKTOP.image}
        alt={icons.ABOUT_GRAPHIC_GRID_1_DESKTOP.altText}
      />
      <GraphicGridMobile
        src={icons.ABOUT_GRAPHIC_GRID_1_MOBILE.image}
        alt={icons.ABOUT_GRAPHIC_GRID_1_MOBILE.altText}
      />
      {confList.map(conference => (
        <PrevConferences conferenceInfo={conference} />
      ))}
      <BasicContentSection section={aboutSections[0].about_page_section} />
      <GraphicGridDesktop
        src={icons.ABOUT_GRAPHIC_GRID_2_DESKTOP.image}
        alt={icons.ABOUT_GRAPHIC_GRID_2_DESKTOP.altText}
      />
      <GraphicGridMobile
        src={icons.ABOUT_GRAPHIC_GRID_2_MOBILE.image}
        alt={icons.ABOUT_GRAPHIC_GRID_2_MOBILE.altText}
      />
      <BasicContentSection section={aboutSections[1].about_page_section} />
      <MarginContainer>
        <TeamImage
          src={icons.TEAM_IMAGE.image}
          alt={icons.TEAM_IMAGE.altText}
        />
      </MarginContainer>
      <GetInvolvedPreview />
    </Layout>
  );
};

export default AboutPage;
